import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class BackendErrorTranslatorService {
    private readonly translationTable: { [backendError: string]: string } = {};

    /**
     * The error provided should be and error returned by the backend API.
     * Those are English by default, so we need to translate them in the console.
     * If a translation isn't found, fallback to English.
     */
    public localizeString(errorFromBackend: string): string {
        return this.translationTable[errorFromBackend] ?? errorFromBackend;
    }

    /** A service/module can add its own backend errors independently. */
    public addTranslations(translations: { [backendError: string]: string }): void {
        for (const backendError of Object.keys(translations)) {
            this.translationTable[backendError] = translations[backendError];
        }
    }
}
